import { GameEntry } from "../../../../services/casino-feed";
import { CmsPage, CmsResponse, GameRef, CasinoService as NextCasinoApi, PageWidget } from "../../../../services/casino/new-api";
import { CategoryWidget, RecentlyPlayedWidget, ProviderWidget, CasinoWidget, FavouritesWidget, ProviderCategoryWidget } from "./logic";

export type CasinoPage = { id?: string, name: string; rows: CasinoWidget[]; };

export class CasinoPagesInfo {
    private pages: { [key: string]: CasinoPage } = {
        "virtual": {
            name: "Virtual",
            rows: [
                { type: "category", data: { category: "c:Featured+Slots", cols: 7, rows: 2, name: "Featured Slots" } } as CategoryWidget,
                { type: "recently-played", data: { cols: 6, rows: 1, name: "Recently Played" } } as RecentlyPlayedWidget,
                { type: "category", data: { category: "c:Crash+Games", cols: 5, rows: 2, name: "Crash Games" } } as CategoryWidget,
                { type: "provider", data: { provider: "smartsoft", cols: 6, rows: 2, name: "Smartsoft" } } as ProviderWidget,
                { type: "provider", data: { provider: "pragmaticplay", cols: 6, rows: 3, name: "Pragmatic Play" } } as ProviderWidget,
                { type: "provider", data: { provider: "spinmatic", cols: 7, rows: 2, name: "Spinmatic" } } as ProviderWidget,
                { type: "provider", data: { provider: "kalamba", cols: 6, rows: 2, name: "Kalamba" } } as ProviderWidget,
                { type: "provider", data: { provider: "betsoft", cols: 7, rows: 2, name: "Betsoft" } } as ProviderWidget,
                { type: "provider", data: { provider: "turbogames", cols: 5, rows: 2, name: "Turbo Games" } } as ProviderWidget,
                { type: "provider", data: { provider: "softionvirtual", cols: 5, rows: 1, name: "Virtual Races" } } as ProviderWidget,
                { type: "provider", data: { provider: "amigogaming", cols: 7, rows: 3, name: "AmigoGaming" } } as ProviderWidget,
                { type: "provider", data: { provider: "bfgames", cols: 7, rows: 1, name: "BFGames" } } as ProviderWidget,
                { type: "provider", data: { provider: "bgaming", cols: 5, rows: 2, name: "BGaming" } } as ProviderWidget,
                { type: "provider", data: { provider: "belatragames", cols: 6, rows: 1, name: "Belatra Games" } } as ProviderWidget,
                { type: "provider", data: { provider: "betgames", cols: 7, rows: 1, name: "Betgames" } } as ProviderWidget,
                { type: "provider", data: { provider: "betsolutions", cols: 5, rows: 2, name: "Betsolutions" } } as ProviderWidget,
                { type: "provider", data: { provider: "boldplay", cols: 6, rows: 1, name: "Boldplay" } } as ProviderWidget,
                { type: "provider", data: { provider: "ctinteractive", cols: 7, rows: 2, name: "CTInteractive" } } as ProviderWidget,
                { type: "provider", data: { provider: "caleta", cols: 6, rows: 1, name: "Caleta" } } as ProviderWidget,
                { type: "provider", data: { provider: "aviator", cols: 5, rows: 1, name: "Aviator" } } as ProviderWidget,
            ] as CasinoWidget[]
        },
        "special-games": {
            name: "Special Games",
            rows: [
                { type: "category", data: { category: "c:New+Games", cols: 6, rows: 1, name: "New Games" } } as CategoryWidget,
                { type: "favourites", data: { cols: 6, rows: 1, name: "Favourites" } } as FavouritesWidget,
                { type: "recently-played", data: { cols: 6, rows: 1, name: "Recently Played" } } as RecentlyPlayedWidget,
                // { type: "category", data: { category: "c:1X2+Virtual", cols: 5, rows: 2, name: "1X2 Virtual" } } as CategoryWidget,
                { type: "providercategory", data: { category: "c:Betsoft", provider: "betsoft-a", cols: 5, rows: 2, name: "Betsoft" } } as ProviderCategoryWidget,
                { type: "providercategory", data: { category: "c:Evoplay", provider: "evoplay", cols: 5, rows: 2, name: "Evoplay" } } as ProviderCategoryWidget,
                { type: "providercategory", data: { category: "c:Turbo+Games", provider: "turbo-games", cols: 5, rows: 2, name: "Turbo Games" } } as ProviderCategoryWidget,
                { type: "providercategory", data: { category: "c:Wazdan", provider: "wazdan", cols: 5, rows: 2, name: "Wazdan" } } as ProviderCategoryWidget,
                { type: "providercategory", data: { category: "c:Mancala", provider: "mancala", cols: 5, rows: 2, name: "Mancala" } } as ProviderCategoryWidget,
                //{ type: "providercategory", data: { category: "c:No+Limit+City", provider:"nolimitcityWC", cols: 5, rows: 2, name: "No Limit City" } } as ProviderCategoryWidget,
                { type: "providercategory", data: { category: "c:Novomatic", provider: "novo-matic", cols: 5, rows: 2, name: "Novomatic" } } as ProviderCategoryWidget,
                { type: "providercategory", data: { category: "c:Pg+Soft", provider: "pgsoft", cols: 5, rows: 2, name: "Pg Soft" } } as ProviderCategoryWidget,
                { type: "providercategory", data: { category: "c:Pragmatic", provider: "pragmatic", cols: 5, rows: 2, name: "Pragmatic" } } as ProviderCategoryWidget,
                { type: "providercategory", data: { category: "c:Habanero", provider: "habanero", cols: 5, rows: 2, name: "Habanero" } } as ProviderCategoryWidget,
                { type: "provider", data: { provider: "pragmaticplay", cols: 6, rows: 3, name: "Pragmatic Play" } } as ProviderWidget,
                { type: 'provider', data: { provider: "spinmatic", cols: 7, rows: 2, name: "Spinmatic" } } as ProviderWidget,
                { type: 'provider', data: { provider: "kalamba", cols: 6, rows: 2, name: "Kalamba" } } as ProviderWidget,
                { type: 'provider', data: { provider: "betsoft", cols: 7, rows: 1, name: "Betsoft" } } as ProviderWidget,
                { type: 'provider', data: { provider: "turbogames", cols: 5, rows: 2, name: "Turbo Games" } } as ProviderWidget,
                { type: "category", data: { category: "c:Keno", cols: 6, rows: 2, name: "Keno" } } as CategoryWidget,
                { type: "category", data: { category: "c:Game+Shows", cols: 6, rows: 1, name: "Game Shows" } } as CategoryWidget,
                { type: "provider", data: { provider: "amigogaming", cols: 7, rows: 3, name: "AmigoGaming" } } as ProviderWidget,
                { type: "provider", data: { provider: "bfgames", cols: 7, rows: 1, name: "BFGames" } } as ProviderWidget,
                { type: "provider", data: { provider: "bgaming", cols: 5, rows: 2, name: "BGaming" } } as ProviderWidget,
                { type: "provider", data: { provider: "belatragames", cols: 6, rows: 1, name: "Belatra Games" } } as ProviderWidget,
                { type: "provider", data: { provider: "betgames", cols: 7, rows: 1, name: "Betgames" } } as ProviderWidget,
                { type: "provider", data: { provider: "betsolutions", cols: 5, rows: 2, name: "Betsolutions" } } as ProviderWidget,
                { type: "provider", data: { provider: "boldplay", cols: 6, rows: 1, name: "Boldplay" } } as ProviderWidget,
                { type: "provider", data: { provider: "ctinteractive", cols: 7, rows: 2, name: "CTInteractive" } } as ProviderWidget,
                { type: "provider", data: { provider: "caleta", cols: 6, rows: 1, name: "Caleta" } } as ProviderWidget,
                { type: "provider", data: { provider: "aviator", cols: 5, rows: 1, name: "Aviator" } } as ProviderWidget,
            ] as CasinoWidget[]
        },
    };
    constructor(pages?: { [key: string]: CasinoPage }) {
        if (pages != null)
            this.pages = pages;
    }
    public getPage(page: string): CasinoPage {
        return this.pages[page];
    }
    public getWidgetBySlug(slug: string): null|CasinoWidget {
        for (let page in this.pages) {
            for (let widget of this.pages[page].rows){
                if ('id' in widget.data && slug == widget.data.id) {
                    return widget;
                }
            }
        }
        return null;
    }
}

export class CmsCasinoPagesFetcher {
    private static pages?: { [key: string]: CasinoPage };

    constructor(
        private readonly casinoApi: NextCasinoApi
    ) {
    }

    async build() {
        const apiPages = await this.casinoApi.fetchCmsPages();
        CmsCasinoPagesFetcher.pages = this.mapPages(apiPages);
        return new CasinoPagesInfo(CmsCasinoPagesFetcher.pages);
    }

    preBuild() {
        if (CmsCasinoPagesFetcher.pages == null)
            return null;
        return new CasinoPagesInfo(CmsCasinoPagesFetcher.pages);
    }

    private mapPages(apiPages: CmsResponse): { [key: string]: CasinoPage } {
        return apiPages.data.pages.map((page: CmsPage): CasinoPage => ({
            id: page.code,
            name: page.name
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' '),
            rows: page.rows.slice(0).sort((a, b) => a.order - b.order).map((widget: PageWidget): CasinoWidget => {
                const widgetMap = {
                    type: widget.type,
                    data: {
                        id: widget.code,
                        name: widget.data.name,
                        rows: widget.data.rows,
                        cols: widget.data.cols,
                        provider: widget.data.provider,
                        category: widget.data.category,
                        icon: null,
                        games: widget.data.games.map((game: GameRef) => ({
                            provider: game.aggregator_id,
                            category: game.brand_id,
                            id: game.game_id
                        }))
                    } as Partial<CasinoWidget['data']>
                };
                return widgetMap as CasinoWidget;
            })
        })).reduce((c, page: CasinoPage) => {
            c[page.id] = page;
            return c;
        }, {});
    }
}